import { Cohorts } from '@platform/client';
import Skeleton from 'react-loading-skeleton';
import { ISO3166Alpha2Code } from '../../../../../../lib/components/src/atoms';
import { useScrollRestoration } from '../../hooks/scroll-restoration';
import { CohortHighlightsSection } from './CohortHighlightsSection';
import { MemberCard } from './MemberCard';

const MyCohortPage = () => {
  const {
    data: myCohortResponse,
    isLoading,
    isError,
    isSuccess,
  } = Cohorts.useGetUserMyCohortData();

  useScrollRestoration();

  return (
    <div className='w-full min-w-0'>
      <h2 className='uppercase font-bold text-gray-400 mb-2'>Your Cohort</h2>
      <h1 className='text-display-md font-bold text-gray-700 mb-2'>You're in good company</h1>
      <p className='text-md font-base text-gray-700 mb-8'>
        Collectively, you have the opportunity to create real change for organizations that need it
        most.
      </p>
      {isLoading && <Skeleton height={240} width='100%' />}
      {(isError || (isSuccess && !myCohortResponse)) && (
        <div className='w-full border border-gray-100 h-56 shadow-xs rounded-xl flex items-center justify-center text-gray-400'>
          Error loading cohort data
        </div>
      )}
      {isSuccess && myCohortResponse && (
        <>
          <CohortHighlightsSection
            totalMembers={(myCohortResponse?.members || []).length}
            countries={myCohortResponse?.countryCount || 0}
            continents={myCohortResponse?.continentCount || 0}
            languages={myCohortResponse?.languageCount || 0}
            skills={myCohortResponse?.skillsCount || 0}
            experienceDistribution={myCohortResponse?.experienceDistribution || {}}
          />
          <div className='grid grid-cols-1 sm:grid-cols-[repeat(auto-fit,minmax(max(280px,calc((100%_-_40px)/3)),1fr))] gap-5 mt-8'>
            {myCohortResponse?.members.map((user) => (
              <MemberCard
                key={user.userId}
                name={user.firstName + ' ' + user.lastName}
                avatarUrl={user.avatarUrl}
                positionTitle={user.positionTitle}
                employer={myCohortResponse?.clientName || user.employer}
                country={user.country}
                countryAlpha2={user.countryIso3166Alpha2 as ISO3166Alpha2Code}
                skills={user.skills}
                userId={user.userId}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MyCohortPage;
